import { CurrentUserGq } from '../../../../graphql/users/models/CurrentUserGq';
import { ProjectGq } from '../../../../graphql/projects/models/ProjectGq';
import { useFormik } from 'formik';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';

export interface CopyProjectFormState {
  oldProjectId: number;
  newName: string;
}

export function useCopyProjectForm(
  project: ProjectGq,
  onSuccess: (result: ProjectGq) => Promise<void>,
  user: CurrentUserGq
) {
  const copyProjectMutation = projectsApiService.mutations.projects.useCopyProject();

  return useFormik<CopyProjectFormState>({
    initialValues: {
      oldProjectId: project.id,
      newName: project.name?.length ? `${project.name} (copy)` : 'Copy',
    },
    onSubmit: (values) => copyProjectMutation(values).then((result) => onSuccess(result)),
  });
}
